"use client"

import { useEffect } from "react"

declare global {
  interface Window {
    __gcse?: {
      parsetags: string
      callback: () => void
    }
  }
}

export default function GoogleSearch() {
  useEffect(() => {
    // Load the Google CSE script
    const script = document.createElement("script")
    script.src = "https://cse.google.com/cse.js?cx=2576f4f1e47f24ce5"
    script.async = true
    document.head.appendChild(script)

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src*="cse.google.com"]')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return (
    <div className="gcse-search-container">
      <div className="gcse-search"></div>
    </div>
  )
}
